// =============================================================================
// src/features/reputation/reputation-live-store.ts
//
// Override vivo (Sentinel/AtalaIA) sobre os dados estáticos de reputação. Quando o
// patch chega da hidratação ao vivo, os getters passam a devolver o índice e a série
// histórica reais do cliente monitorado; sem patch, caem nos valores estáticos.
// SRP: só o estado de override + getters. Sem DOM, sem fetch.
// =============================================================================

import { REPUTATION_TREND, REPUTATION_TREND_LABELS } from './reputation-data';
import type { ReputationLivePatch } from '../../data/sentinel-overlay';

/** Baseline/fallback do índice sem override ao vivo (último ponto da série estática, 53,15). */
const FALLBACK_INDEX = 53.15;

let liveIndexOverride: number | null = null;
let liveTrendOverride: readonly number[] | null = null;
let liveTrendLabelsOverride: readonly string[] | null = null;

/** Índice atual do cliente vivo; sem override, usa o baseline estático. */
export function getLiveReputationIndex(): number {
  return liveIndexOverride ?? FALLBACK_INDEX;
}

/** Série histórica do índice (override ao vivo ou a estática). */
export function getReputationTrend(): readonly number[] {
  return liveTrendOverride ?? REPUTATION_TREND;
}

/** Rótulos da série histórica (override ao vivo ou os estáticos). */
export function getReputationTrendLabels(): readonly string[] {
  return liveTrendLabelsOverride ?? REPUTATION_TREND_LABELS;
}

/** Último ponto da série (usado pelo gauge "agora"). */
export function getReputationTrendEnd(): number {
  if (liveIndexOverride != null) return liveIndexOverride;
  const series = getReputationTrend();
  /* v8 ignore next -- série nunca é vazia (REPUTATION_TREND ou override length>0); ?? exigido por noUncheckedIndexedAccess */
  return series[series.length - 1] ?? FALLBACK_INDEX;
}

export function applyReputationLivePatch(patch: ReputationLivePatch): void {
  if (patch.index != null) liveIndexOverride = patch.index;
  if (patch.trend != null && patch.trend.length > 0) liveTrendOverride = patch.trend;
  if (patch.trendLabels != null && patch.trendLabels.length > 0) {
    liveTrendLabelsOverride = patch.trendLabels;
  }
}

export function __resetReputationLiveForTests(): void {
  liveIndexOverride = null;
  liveTrendOverride = null;
  liveTrendLabelsOverride = null;
}
